import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { serializeFilters } from '@user/components/Filters'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { FunnelFilterType, SalesFunnelFilterSet } from '../filters'
import { useSelector } from 'react-redux'
import { setSalesFunnelSummaryFilters } from '../slice'

export const useSaveSalesFunnelSummaryFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const salesFunnelPref = useMemo(
    () => prefs.find((p) => p.type === 'salesFunnelSummary'),
    [prefs],
  )

  return useCallback(
    (model: SalesFunnelFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: salesFunnelPref?.id,
          type: 'salesFunnelSummary',
          name: 'sales funnel summary filters',
          filter: serializeFilters<FunnelFilterType, SalesFunnelFilterSet>(
            model,
          ),
        }),
      )
      dispatch(setSalesFunnelSummaryFilters(model))
    },
    [dispatch, salesFunnelPref?.id],
  )
}
